import { UserDataGroupsResponse } from '@ariksa/abac/api';
import {
  AccessRequestCreateResponse,
  ItemApiGetSnowflakePrivilegeCatalogRequest,
  JitDataGroupStatusesResponse,
  SnowflakePrivilegeCatalogResponse,
} from '@ariksa/jit';
import { QueryAction } from 'services/types';
import { QueryState } from 'services/utils/QueryState';

import {
  GetDataGroupsSensitivityAction,
  updateDataGroupSensitivityStates,
} from 'containers/Jit/Components/dataGroupSensitivityUtils';
import { createSlice } from 'utils/@reduxjs/toolkit';

import { ContainerState } from './types';

export const initialState: ContainerState = {
  dataGroups: QueryState.init({} as UserDataGroupsResponse),
  dataGroupSensitivity: {},
  dataGroupStatuses: QueryState.init({} as JitDataGroupStatusesResponse),
  requestAction: QueryState.init({} as AccessRequestCreateResponse),
  privilegeCatalog: QueryState.init({} as SnowflakePrivilegeCatalogResponse),
};

const dataCatalogSlice = createSlice({
  name: 'dataCatalog',
  initialState,
  reducers: {
    getDataGroups(state, action: QueryAction<UserDataGroupsResponse>) {
      state.dataGroups = QueryState.next(state.dataGroups, action);
    },
    // Stores one bulk sensitivity response per data group id; a per-row
    // request here is an N+1 (Sentry ARIKSA-UI-ND).
    getDataGroupsSensitivity(state, action: GetDataGroupsSensitivityAction) {
      updateDataGroupSensitivityStates(state.dataGroupSensitivity, action);
    },
    getDataGroupStatuses(
      state,
      action: QueryAction<JitDataGroupStatusesResponse>,
    ) {
      state.dataGroupStatuses = QueryState.next(
        state.dataGroupStatuses,
        action,
      );
    },
    createRequest(state, action: QueryAction<AccessRequestCreateResponse>) {
      state.requestAction = QueryState.next(state.requestAction, action);
    },
    getPrivilegeCatalog(
      state,
      action: QueryAction<
        SnowflakePrivilegeCatalogResponse,
        ItemApiGetSnowflakePrivilegeCatalogRequest
      >,
    ) {
      state.privilegeCatalog = QueryState.next(state.privilegeCatalog, action);
    },
  },
});

export const { actions, reducer, name: sliceKey } = dataCatalogSlice;
